// Shared constants for membership details components

export const ACTIVITY_TYPES = {
  PAT: "Playing Ability Test (PAT)",
  INTEREST_FORM: "PGA Membership Interest Form",
  ASSOCIATE_APPLICATION: "Associate Program Application",
  ELIGIBLE_EMPLOYMENT: "Eligible Employment",
  QUALIFYING_LEVEL: "Qualifying Level Courses",
  BACKGROUND_CHECK: "Background Check",
  PGA_ACCOUNT: "PGA Account"
} as const;
